import { useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { trackPageView } from "../services/analytics";
import routesConfig from "../data/routes";

function titleForPathname(pathname) {
  var p = String(pathname || "").trim();
  if (!p || p === "/") return "UUD";
  if (p === "/tools") return "UUD - Tools";
  if (p === "/resos") return "UUD - resos";
  if (p === "/ideaz") return "UUD - ideaz";
  if (p === "/apps") return "UUD - Apps";
  if (p === "/setting") return "UUD - Setting";
  if (p === "/signup" || p.startsWith("/confirm-signup") || p.startsWith("/signup-request")) return "UUD - Signup";
  if (p === "/dashboard") return "UUD - Dashboard";
  if (p === "/alertstylelab") return "UUD - Alert style lab";
  if (p === "/camp/event") return "UUD - Schoolup Camp Event";
  if (p === "/camp/event/privacy") return "UUD - Camp Event Privacy (JA)";
  if (p === "/adminlogin") return "UUD - Admin";
  if (p.startsWith("/confirm-password-reset")) return "UUD - Reset Password";
  if (p.startsWith("/confirm-verification")) return "UUD - Email Verification";
  if (p.startsWith("/confirm-email-change")) return "UUD - Email Change";
  if (p.startsWith("/auth/confirm-")) return "UUD";
  // likely /:username
  if (p.startsWith("/") && p.length > 1 && p.indexOf("/", 1) === -1) return "UUD - Profile";
  return "UUD";
}

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    var path = location.pathname;
    try {
      var matches = matchRoutes(
        routesConfig.map(function (r) {
          return { path: r.path };
        }),
        location
      );
      var last = matches && matches[matches.length - 1];
      if (last && last.route && last.route.path === "*") {
        document.title = "UUD - Page not found";
      } else {
        document.title = titleForPathname(path);
      }
    } catch (_) {}
    var t = setTimeout(function () {
      trackPageView(path);
    }, 50);
    return function () {
      clearTimeout(t);
    };
  }, [location.pathname, location.search]);

  return null;
}
